import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import ToastService from "../common/toast/toast_service";

const ProtectedRoutes: React.FC = () => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      ToastService.showError("Please log in to access this page.");
    }
  }, [isAuthenticated, location.pathname]);

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace state={{ from: location.pathname }} />
  );
};

export default ProtectedRoutes;
